// src/services/tournamentService.js
// REST client for Sit & Go tournaments (backend routes: /api/tournaments).
import api from './api';

class TournamentService {
  async listTournaments(status = null) {
    const url = status ? `/api/tournaments?status=${encodeURIComponent(status)}` : '/api/tournaments';
    const res = await api.get(url);
    return res.tournaments || [];
  }

  async getTournament(id) {
    const res = await api.get(`/api/tournaments/${id}`);
    return res.tournament || null;
  }

  async createTournament(data) {
    return api.post('/api/tournaments', data);
  }

  async updateTournament(id, data) {
    return api.put(`/api/tournaments/${id}`, data);
  }

  async registerForTournament(id) {
    return api.post(`/api/tournaments/${id}/register`);
  }

  async getStandings(id) {
    return api.get(`/api/tournaments/${id}/standings`);
  }

  async deleteTournament(id) {
    return api.delete(`/api/tournaments/${id}`);
  }

  async setTournamentActive(id, isActive) {
    return api.patch(`/api/tournaments/${id}/active`, { isActive });
  }

  async closeRegistration(id) {
    return api.post(`/api/tournaments/${id}/close-registration`);
  }
  async listMyTournaments() {
    const res = await api.get('/api/tournaments/my');
    return res.tournaments || [];
  }

  async joinByCode(code, realName = null) {
    return api.post('/api/tournaments/join-by-code', { code, realName });
  }

  async submitTournamentRequest(data) {
    return api.post('/api/tournaments/requests', data);
  }

  async listTournamentRequests() {
    const res = await api.get('/api/tournaments/requests');
    return res.requests || [];
  }

  async listMyTournamentRequests() {
    const res = await api.get('/api/tournaments/requests/my');
    return res.requests || [];
  }

  async createRentalTournament(requestId, data) {
    return api.post(`/api/tournaments/requests/${requestId}/create`, data);
  }

  async setTournamentRequestStatus(requestId, status, reason = null) {
    return api.patch(`/api/tournaments/requests/${requestId}`, { status, reason });
  }

  async updateTournamentSchedule(id, data) {
    return api.put(`/api/tournaments/${id}/schedule`, data);
  }

  async setPlayerApproval(id, userId, approved) {
    return api.post(`/api/tournaments/${id}/players/${userId}/approve`, { approved });
  }

  async getTournamentMonitor(id) {
    return api.get(`/api/tournaments/${id}/monitor`);
  }

}

export const tournamentService = new TournamentService();
export default tournamentService;

// Private-tournament rental fee tiers (USD), shared with the UI for live preview.
export function calculateRentalFee(playerCount) {
  const n = parseInt(playerCount, 10) || 0;
  if (n < 24) return null;
  if (n <= 25) return 10;
  if (n <= 50) return 15;
  if (n <= 100) return 25;
  return 25 + (n - 100) * 0.2;
}